<ng-container *ngIf="dataloaded">
  <!-- Modal -->
  <div *ngIf="modal" class="modal-dialog modal-dialog-centered">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="h4 modal-title">{{ 'fileupload.fileupload' | trans }}</h4><button type="button" class="close"
          data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="custom-file">
          <input type="file" (change)="selectFile($event)" class="custom-file-input" id="validatedCustomFile" required>
          <label id="customvalidator" class="custom-file-label" for="validatedCustomFile">{{selectedFiles ?
            selectedFileName :
            'fileupload.fileuploadhelp' | trans}}</label>
        </div>
        <div class="row" style="margin-top:10px;">
          <div class="col">
            <button data-dismiss="modal" style="width:100%;" class="btn-close">
              <h6 class="btn-save-text">{{ 'fileupload.close' | trans }}</h6>
            </button>
          </div>
          <div class="col">
            <button style="width:100%;" (click)="onDocumentSubmit()" data-dismiss="modal" type="button"
              class="btn-save float-right">
              <h6 class="btn-save-text">{{ 'fileupload.save' | trans }}</h6>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!modal">
    <app-alertbox *ngIf="showdeletealert" [@inbgOutAnimation] [alerticon]="'delete'" [alertdisplay]="'modal'"
      [alerttype]="'error'" [alerttext]="'fileupload.fileuploaddelete' | trans "></app-alertbox>
    <app-alertbox *ngIf="showalert" [@inbgOutAnimation] [alerticon]="'check_circle'" [alertdisplay]="'modal'"
      [alerttype]="'success'" [alerttext]="'fileupload.fileuploadsuccess' | trans "></app-alertbox>
    <app-loadconfirm *ngIf="showSpinner" [icon]="'pending'"></app-loadconfirm>
    <div class="row" style="position: relative;">
      <div class="col">
        <label (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="fileUpload.click()"
          [ngClass]="{'border-succes': fileUploadedtoggle == true}" class="file-container " id="validatorcustom">
          <div class="">
            <span class="file-container-name text-center">{{taskInputName}}</span>
            <span *ngIf="fileUploadedtoggle" class="material-icons align-middle c-save"
              style="padding-bottom: 5px; padding-left:5px; position: absolute; top: 40%; right:50px;">
              task_alt
            </span>
          </div>
          <span class="nowrap text-truncate text-center d-block" style="width:90%; padding-left:5%;">
            {{selectedFileName || ('fileupload.fileuploadhelp' | trans)}}
          </span>
        </label>
        <input type="file" (change)="selectFile($event)" class="d-none" id="validatedCustomFile" #fileUpload required>
      </div>
      <div *ngIf="fileUploadedtoggle" class="" style="position: absolute; right: 0px; top: 0px;">
        <div class="file-container-options">
          <ng-container *ngIf="!deletecontrol">
            <button (click)="deletetoggler(true)" class="btn d-flex">
              <span class="material-icons f-20 btn-icon lh-25">
                delete
              </span>
            </button>
            <button *ngIf="downloadtoggle" class="btn d-flex">
              <span class="material-icons f-20 btn-icon lh-25" (click)="getSignedUrl(orgfile)">
                download
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="deletecontrol">
            <button (click)="deletetoggler(false)" class="btn d-flex btn-icon-close">
              <span class="material-icons f-20 btn-icon lh-25">
                close
              </span>
            </button>
            <button class="btn d-flex btn-icon-save" (click)="deleteFile(orgfile)">
              <span class="material-icons f-20 btn-icon lh-25">
                check
              </span>
            </button>
          </ng-container>
        </div>
      </div>
    </div>



    <!---- <div class="col pr-0">
      <button *ngIf="fileUploadedtoggle" [ngClass]="{'btn-nohover': !uploaddisabled}" (click)="onDocumentSubmit()"
        [disabled]="!uploaddisabled" type="button" class="btn btn-noround">
        <p class="btn-text mb-0" style="font-weight: 500;">{{ 'cpllist.datasubmitted'
          | trans }}</p>
      </button>

      <button *ngIf="!fileUploadedtoggle" [ngClass]="{'btn-nohover': !uploaddisabled}" (click)="onDocumentSubmit()"
        [disabled]="!uploaddisabled" type="button" class="btn btn-noround">
        <p class="btn-text mb-0" style="font-weight: 500;">{{ 'cpllist.submit'
          | trans }}</p>
      </button>
    </div>-->
    <!-- <button style="width:100%;" (click)="onDocumentSubmit()" data-dismiss="modal" type="button"
            class="btn-save float-right">
            <h6 class="btn-save-text">{{ 'fileupload.save' | trans }}</h6>
          </button> -->
  </div>
</ng-container>